import { PortableText } from '@portabletext/react';
import { GatsbyImage } from 'gatsby-plugin-image';
import React from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import imgFallback from 'src/utils/image';
import './LifeAt.scss';

function LifeAt({ lifeAt }) {
  const { title, intros, image, descriptions } = lifeAt;

  return (
    <Container fluid className="bg-darker overflow-hidden">
      <Row className="life-at">
        <Col xs={12} className="px-0">
          <Container>
            <Row>
              <Col xs={12} xl={{ span: 11, offset: 1 }} className="pt-6">
                <h2 className="pt-6 text-white">{title ?? '[title]'}</h2>
              </Col>
            </Row>
          </Container>
        </Col>

        {intros?.length > 0 && (
          <Col xs={12} className="px-0 py-3">
            <Container>
              <Row>
                {intros.map((el) => (
                  <Col key={el._key} xs={12} md={6} xl={{ span: 5, offset: 1 }} className="py-3 text-white">
                    <PortableText value={el.description} />
                  </Col>
                ))}
              </Row>
            </Container>
          </Col>
        )}

        {image && (
          <Col xs={12} className="px-0 py-6">
            <Row className="justify-content-center align-items-center">
              <Col xs={12} className="py-3">
                <GatsbyImage alt={image.alt ?? ''} image={image?.image?.asset?.gatsbyImageData ?? imgFallback} />
              </Col>
            </Row>
          </Col>
        )}

        {descriptions?.length > 0 && (
          <Col xs={12} className="last px-0 py-6">
            <Container>
              <Row>
                {descriptions.map((el) => (
                  <Col key={el._key} xs={12} md={6} xl={{ span: 5, offset: 1 }} className="text-item text-muted py-3">
                    <PortableText value={el.description} />
                  </Col>
                ))}
              </Row>
            </Container>
          </Col>
        )}
      </Row>
    </Container>
  );
}

export default LifeAt;
